import React, { useState } from "react";
import { Reorder, useDragControls } from "framer-motion";
import { Icon } from "../Icon";
import { useDispatch } from "react-redux";
import { editWorkouts } from "../../redux/actions/workouts";
import { Icon as Button } from "../Icon";
import { useParams } from "react-router";


const EditPlanForm = (props) => {
  const dispatch=useDispatch();
  const [form, setForm] = useState(props.item);
  const [inputValue, setInputValue] = useState('');
  const currentId=useParams().id
  const backgroundClick = (e) => {
    if (e.target.className === "formBackground") {
      props.setFormActive(false);
    }
  };

  // const dayClick = (e) => {
  //   let arr = form.weekDays || [];
  //   if (arr.indexOf(e.currentTarget.id) >= 0) {
  //     arr.splice(arr.indexOf(e.currentTarget.id), 1);
  //   } else {
  //     arr.push(e.currentTarget.id);
  //   }
  //   setForm({ ...form, weekDays: arr });
  // };

  const heandleRemovePoint = (index) => {
      let arr =form.exercises;
      arr.splice(index,1);
    setForm({...form,['exercises']:[...arr]});
  };

  const reorderClick = (e) => {
    e.map((el, index) => {
      el.pointIndex = index;
    });
    setForm({...form,['exercises']:e})
  };

  const handleClick = () => {
    // alert("click");
  };
  const editClick =()=>{
      let body = form;
      body.id=form.id;
    if(!body.isOnce){
        body.isOnce=false;
    }
    body.isActive=true;
    body.type='Тренування'
    if(props.videoId){
      body.videoId=props.videoId;
    }
    dispatch(editWorkouts(body)).then(res=>{
      props.setReady(false);
      props.setPlanReady(false);
    })
    props.closeClick();
  }
const submitClick=()=>{
    setForm({...form,['exercises']:[...form.exercises || [], inputValue]})
    setInputValue('')
}
  const changeHandler=(e)=>{
    setForm({ ...form, [e.target.id]: e.target.value });
  }
  const changeExerciseItem=(e)=>{
    //   let data={pointIndex:form.exercises?.length?form.exercises.length :0,
    //     value: e.target.value}
    let data= e.target.value;
    setInputValue(data)
  }
  console.log(form);
  return (
    <div className='formBackground' onClick={backgroundClick}>
      <div className="formBlock">
        <div className="apFilterHeader form">
          <h2>Редагувати тренування</h2>
          <Button
              type={"cross"}
              className={"cross"}
              onClick={props.closeClick}
            />
          {/* <button
            className="secondarySmallRoundedButtonTextDefault"
            style={{ fontWeight: "200" }}
            onClick={props.closeClick}
          >
            X
          </button> */}
        </div>
        <h2>Назва</h2>
        <div className="apInputTextIcon form">
          <div>
            <input
              onChange={changeHandler}
              id="title"
              type="text"
              value={form.title || ''}
              placeholder="Введіть назву тренування"
            />
          </div>
        </div>
        {/* <input placeholder='Введіть назву тренування' type="text" /> */}
        <h2>Дні тренування:</h2>


        <div className="weekList">
          {form.weekDay===0&& <div
            className={
             "weekListItem active"
            }
            accessKey="weekDay"
            style={{width:'fit-content',padding:'20px 10px'}}
            id="0"
          >
            Понеділок
          </div>}
          {form.weekDay===1&& <div
             className={
              "weekListItem active"
             }
            accessKey="weekDay"
            style={{width:'fit-content',padding:'20px 10px'}}
            id="1"
          >
            Вівторок
          </div>}
          {form.weekDay===2&& <div
            className={
              "weekListItem active"
             }
            accessKey="weekDay"
            style={{width:'fit-content',padding:'20px 10px'}}
            id="2"
          >
            Середа
          </div>}
          {form.weekDay===3&& <div
             className={
              "weekListItem active"
             }
            accessKey="weekDay"
            style={{width:'fit-content',padding:'20px 10px'}}
            id="3"
          >
            Четверг
          </div>}
          {form.weekDay===4&& <div
            className={
              "weekListItem active"
             }
            accessKey="weekDay"
            style={{width:'fit-content',padding:'20px 10px'}}
            id="4"
          >
            Пʼятниця
          </div>}
          {form.weekDay===5&& <div
             className={
              "weekListItem active"
             }
            accessKey="weekDay"
            style={{width:'fit-content',padding:'20px 10px'}}
            id="5"
          >
            Суббота
          </div>}
          {form.weekDay===6&& <div
             className={
              "weekListItem active"
             }
            accessKey="weekDay"
            style={{width:'fit-content',padding:'20px 10px'}}
            id="6"
          >
            Неділя
          </div>}
        </div>
        <h2>Оберіть час:</h2>
        <div className="timePickerWrap">
          <div className="timeList">
            <div className="timePicker">
              <input type="time" id="startTime" value={form.startTime|| ''} onChange={changeHandler}/>
              <Icon type={"time"} />
            </div>
            <div className="timePicker">
              <input type="time"  id="finishTime" value={form.finishTime|| ''} onChange={changeHandler}/>
              <Icon type={"time"} />
            </div>
          </div>
          <div className="apCheckBoxWithLabel">
            <label htmlFor="profileDeactivation">Періодичне</label>
            <input
              id="profileDeactivation"
              type="checkbox"
              className="apCheckbox"
              checked={form.isOnce}
              onChange={(e)=>setForm({ ...form, ["isOnce"]: !form.isOnce })}
            />
            <label htmlFor="profileDeactivation">Разове</label>
          </div>
        </div>

        <h2>Вправи:</h2>
        <div className="trainingStepsWrap">
          {form.exercises?.length > 0 && (
            <Reorder.Group
              axis="y"
              values={form.exercises}
              onReorder={reorderClick}
              layoutScroll
              style={{ overflowY: "scroll", maxHeight: "200px" }}
            >
              {form.exercises.map((item, index) => (
                <Item
                  key={`${item}.${index}`}
                  handleClick={handleClick}
                  value={item}
                  item={item}
                  onDelete={() => heandleRemovePoint(index)}
                />
              ))}
            </Reorder.Group>
          )}
          <div className="apInputText trainingAppInput">
            <input placeholder="Додати вправу" type="text" value={inputValue ||''} onChange={changeExerciseItem} />
            <Icon
              type={"submitArrow"}
              onClick={submitClick}
            />
          </div>
        </div>
        <div className="formButtonGroup">
          <Icon
            type={"file"}
            children={"Редагувати тренування"}
            onClick={editClick}
          />
          <Icon
            type={"roundCross"}
            children={"Скасувати"}
            onClick={props.closeClick}
          />
        </div>
      </div>
    </div>
  );
};

const Item = (props) => {
  const controls = useDragControls();

  return (
    <Reorder.Item
      value={props.value}
      dragListener={false}
      dragControls={controls}
    >
      <div className="trainingReordeItem">
        {props.value}
        <div className="controls">
          <Icon className={"cross"} type={"cross"} onClick={props.onDelete} />
          <button
            className="dragButton"
            onPointerDown={(e) => controls.start(e)}
          >
            <Icon type={"list"} />
          </button>
        </div>
      </div>
    </Reorder.Item>
  );
};

export default EditPlanForm;
